module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_kyushu-okinawa_pc_3eb742ccffde0636015a1e743119e279.png";